/* eslint-disable max-len */
import { ChartTypes } from '@configs/graph';
import { sortOrders } from '@constants/sort';
import { IReportConfig } from '@typings/reports';

const reportConfig: IReportConfig = {
    reportTitle: 'Источники переходов',
    tableDataType: 'static',
    tableTitle: 'Источник перехода, источник детально',
    defaultSort: {
        name: 'visits',
        order: sortOrders.DESC,
    },
    numberOfGraphs: 'two',
    defaultGraphs: [
        ChartTypes.pie,
        ChartTypes.bar,
    ],
    graphDefaultMetrics: [
        'visits',
        'page_views',
    ],
    titleAliases: {
        straight: 'Прямые заходы',
        site: 'По ссылкам на сайтах',
        social: 'Социальные сети',
        email: 'Почтовые рассылки',
        search: 'Поисковые системы',
        internal: 'Внутренние переходы',
        adv: 'Рекламные системы',
        local_page: 'Сохраненные страницы',
    },
    tableDefaultMetrics: [
        'visits',
        'page_views',
        'avg_view_depth',
    ],
    availableMetrics: [
        'visits',
        'avg_view_depth',
        'page_views',
        'visitors',
        'uid',
        'rambler_id',
        // 'bounces',
        // 'avg_industry_duration',
    ],
    disabledSortBy: ['title'],
    isShowTotals: true,
    availableTools: {
        numberOfGraphs: true,
        periodPicker: true,
        sample: true,
        activeSample: true,
        filters: true,
        savedFilters: true,
        detail: true,
    },
    reportHint: {
        message: 'За каждым визитом на сайт стоит определённый источник перехода – то, откуда пришел посетитель на сайт. '
            + 'Счётчик Статистики от SberAds систематизирует данные источники в определённые группы.',
    },
};

export default reportConfig;

